import githubSmallIcon from '../../../assets/icons/github-small-icon.svg';
import jiraSmallIcon from '../../../assets/icons/icon-jira.svg';
import gitlabSmallIcon from '../../../assets/icons/icon-gitlab.svg';
import trelloSmallIcon from '../../../assets/icons/icon-trello.svg';
import notionSmallIcon from '../../../assets/icons/icon-notion.svg';
import { shopifySm, chatgptSm, claudeSm } from '../../../assets/images/platforms';

export const PLATFORM_ICONS: Record<string, string> = {
  Notion: notionSmallIcon,
  GitLab: gitlabSmallIcon,
  Trello: trelloSmallIcon,
  Jira: jiraSmallIcon,
  GitHub: githubSmallIcon,
  Shopify: shopifySm,
  ChatGPT: chatgptSm,
  Claude: claudeSm,
};
